import React from 'react';
import TopMenu from './TopMenu';
import './Header.css';

const Header: React.FC<HeaderProps> = () => {
    return (
        <>
            <TopMenu />
            <header className="page-header">
                {/* <div className="header-content">
                    <div className="restaurant-info">
                        <h1 className="restaurant-name">
                            <img src="/files/Logo1_white.png" alt="Logo" className="logo-image" />
                            <span className="brand-text"><span className="brand-deli">deli</span>feed.com</span>
                        </h1>
                        <p className="restaurant-tagline">
                            Freshly made and delivered from our family kitchen in Upper Cambourne.
                        </p>
                    </div>
                </div> */}
            </header>
        </>
    );
};

export default Header;
